import FileSaver from 'file-saver';
import axios from 'lib/apiClient';
import get from 'lodash/get';
import { toUserTimezone } from 'utils';
import apiClient from '../lib/apiClient';
import { fileToObject } from './files.service';
/*
/messages/add
 */

export const addMessage = async ({
  recepient_type,
  recepient_ids,
  attachments,
  ...other
}) => {
  return Promise.all(
    recepient_ids.map(async (id) => {
      const formData = new FormData();
      Object.keys(other).forEach((key) => {
        const value = other[key];
        if (value) {
          formData.append(key, value);
        }
      });

      if (recepient_type === 'groups') {
        formData.append('recipient_id', id);
        formData.append('recipient_type', 'group');
      } else {
        if (id === '0') {
          formData.append('recipient_id', id);
          formData.append('recipient_type', 'all');
        } else {
          formData.append('recipient_id', id);
          formData.append('recipient_type', 'contact');
        }
      }

      const resp = await axios.post('API/1_0/message.php', formData);
      if (attachments) {
        return Promise.allSettled(
          attachments.map((attachment) => {
            return fileToObject('message', resp.msg_id, attachment.file_id);
          }),
        );
      }
      return resp;
    }),
  );
};

export const updateMessage = async (hash, values) => {
  values.hash = hash;
  const msg = await axios.post('API/1_0/message.php', values);
  if (values.files) {
    await Promise.allSettled(
      values.files.map((file) => {
        return fileToObject('message', msg.msg_id, file.file_id);
      }),
    );
  }
  return msg;
};

export const getGroupMessages = (query) =>
  axios.get('API/1_0/getGroupMessages.php', { params: query });

export const getMessage = (query) => {
  return axios.get('API/1_0/message.php', { params: query });
};

export const deleteMessage = (hash) =>
  axios.delete('API/1_0/message.php', { params: { hash } });

export const exportMessages = async (account, isGroupExport) => {
  let data = null;

  if (isGroupExport) {
    data = await getGroupMessages({
      msg_sent: 1,
      msg_incoming: '0',
      load_groups: 1,
      order_by: 'msg_send_time',
      sort_dir: 'desc',
    });
  } else {
    data = await getMessage({
      msg_sent: 1,
      msg_incoming: '0',
      load_contacts: 1,
      order_by: 'msg_send_time',
      sort_dir: 'desc',
    });
  }

  data = data.map((i) => ({
    'Message Title': i.msg_name || '',
    Message: i.msg_content || '',
    'Message Sent Time': toUserTimezone(
      i.msg_send_time,
      account.account_timezone,
    ).format('LLL'),
    'First Name': get(i, 'contacts.0.contact_first_name', ''),
    'Last Name': get(i, 'contacts.0.contact_last_name', ''),
    Groups: get(i, 'groups.0.group_name'),
    recipients: get(i, 'contacts.length') || 1,
  }));

  return apiClient
    .post('API/1_0/postCSVfromJSON.php', { rows: data })
    .then((csv) => {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      FileSaver.saveAs(blob, 'message_sent.csv');
    });
};

export const exportIncomingMessages = async (account) => {
  const data = await getMessage({
    msg_incoming: 1,
    load_contacts: 1,
    order_by: 'msg_send_time',
    sort_dir: 'desc',
  });

  if (!data.length) {
    throw new Error('No incoming messages found');
  }

  const formatted = data.map((i) => ({
    Message: i.msg_content || '',
    'Message Received Time': toUserTimezone(
      i.msg_stamp,
      account.account_timezone,
    ).format('LLL'),
    'First Name': get(i, 'contacts.0.contact_first_name', ''),
    'Last Name': get(i, 'contacts.0.contact_last_name', ''),
    'Primary Number': get(i, 'contacts.0.primary_phone', ''),
  }));

  return apiClient
    .post('API/1_0/postCSVfromJSON.php', { rows: formatted })
    .then((csv) => {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      FileSaver.saveAs(blob, 'messages_received.csv');
    });
};

export const getReceipt = (hash) =>
  apiClient.get('API/1_0/receipt.php', { params: { hash } });

export const getMessageByHash = (hash) =>
  apiClient
    .get('API/1_0/getMessageByHash.php', { params: { hash } })
    .then((r) => r[0]);

export const getReceiptStatus = (rcptId) =>
  apiClient.get('API/1_0/receiptStatus.php', { params: { rcp_id: rcptId } });

export const getTemplates = (params) =>
  apiClient.get('API/1_0/messageTemplates.php', { params });

export const getTemplate = (hash) =>
  apiClient
    .get('API/1_0/messageTemplates.php', { params: { hash } })
    .then((r) => r[0]);

export const saveTemplate = (data) =>
  apiClient.post('API/1_0/messageTemplates.php', data);

export const deleteTemplate = (hash) =>
  apiClient.delete('API/1_0/messageTemplates.php', { params: { hash } });

export const getAIReply = (contact_id) =>
  apiClient.post('API/1_0/postAISuggestReply.php', {
    contact_id,
  });

export const shortenMessage = (text) =>
  apiClient.post('API/1_0/postAIReworkMessage.php', {
    rework_type: 'shorten',
    msg_content: text,
  });

export const enhanceMessage = (text, maxLength) =>
  apiClient.post('API/1_0/postAIReworkMessage.php', {
    rework_type: 'enhance',
    msg_content: text,
    max_length: maxLength,
  });

export const translateMessage = (text, language = 'english') =>
  apiClient.post('API/1_0/postAIReworkMessage.php', {
    rework_type: 'translate',
    msg_content: text,
    language,
  });
